export enum cargoReleaseCreateTypes {
    GET_FiltersCreateCR = '@@cargoRelease/GET_FiltersCreateCR',
    GET_FiltersCreateCR_SUCCESS = '@@cargoRelease/GET_FiltersCreateCR_SUCCESS',
    GET_FiltersCreateCR_FAIL = '@@cargoRelease/GET_FiltersCreateCR_FAIL',

    CREATE_CR = '@@cargoRelease/CREATE_CR',
    CREATE_CR_SUCCESS = '@@cargoRelease/CREATE_CR_SUCCESS',
    CREATE_CR_FAIL = '@@cargoRelease/CREATE_CR_FAIL',

    GET_FiltersListItemAggregation = '@@cargoRelease/GET_FiltersListItemAggregation',
    GET_FiltersListItemAggregation_SUCCESS = '@@cargoRelease/GET_FiltersListItemAggregation_SUCCESS',
    GET_FiltersListItemAggregation_FAIL = '@@cargoRelease/GET_FiltersListItemAggregation_FAIL',

    GET_COMMODITY_DEFINITIONS = '@@ItemsAggregation/GET_COMMODITY_DEFINITIONS',
    GET_COMMODITY_SUCCESS = '@@ItemsAggregation/GET_COMMODITY_SUCCESS',
    GET_COMMODITY_FAIL = '@@ItemsAggregation/GET_COMMODITY_FAIL',


    GET_ADDRESS_BY_ENTITY_NAME = '@@ItemsAggregation/GET__ADDRESS_BY_ENTITY_NAME',
    GET_ADDRESS_BY_ENTITY_NAME_SUCCESS = '@@ItemsAggregation/GET__ADDRESS_BY_ENTITY_NAME_SUCCESS',
    GET_ADDRESS_BY_ENTITY_NAME_FAIL = '@@ItemsAggregation/GET__ADDRESS_BY_ENTITY_NAME_FAIL',
  }